import React, { Component } from 'react'
import moment from 'moment'
import { Link } from 'react-router'
import { Button }from 'react-bootstrap'
import PaginationButtons from '../../../containers/Sections/Propiedades/pagination'
import ActionBar from './ActionBar'
import { translate } from "react-translate"

@translate("News")
export default class News extends Component {

  componentWillMount(){
    window.scrollTo(0,0)
    this.props.loadNews()
  }

  _renderDate(date){
    moment.locale('es');
    var m = moment(date)
    let day = moment(m).format('dddd')
    let newDate = moment(m).format('LL')
    return (
      <div className="transform-date">
        <p className="week-day">{day}</p><p>{newDate}</p>
      </div>
    )
  }

  render () {

    const { news, onChangeOrder, order, t } = this.props
    
    let baseUrl = window.location.origin;
    let newsUrl = baseUrl + '/noticias';

    return (
    	<div id="top" name="top" className="news-container container-fluid">    
        <ol className="route-info hidden-xs" itemScope itemType="http://schema.org/BreadcrumbList">
          <li itemProp="itemListElement" itemScope itemType="http://schema.org/ListItem">
            <a href={ baseUrl } itemProp="item" itemType="http://schema.org/Thing">
              <span itemProp="name"><small>{t("Informacion_Novedades")}</small></span>
              <meta itemProp="position" content="1" />
            </a>
          </li>
          
          <i className="fa fa-angle-right"></i>
          
          <li itemProp="itemListElement" itemScope itemType="http://schema.org/ListItem">
            <a href={ newsUrl } itemProp="item" itemType="http://schema.org/Thing">
              <span itemProp="name"><small>{t("Noticias")}</small></span>
              <meta itemProp="position" content="2" />
            </a>
          </li>
        </ol>
        
        <ActionBar onChangeOrder={onChangeOrder} order={order} />
        <h1>{t("Ultimas_Noticias")} </h1>
        {news.map((item, index) =>
          <div className="news-item" key={index}>
            <h2>{item.title}</h2>
            <div className="bottom-info">
              {this._renderDate(item.date)}
              <Button className="btn-note"><a target="_blank" href={item.link}>{t("Ver_Nota")} </a></Button>
            </div>
          </div>
        )}
        <PaginationButtons />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Sections/News/index.js